import { useEffect, useState, useContext } from "react";
import { useToastAction } from "../../hooks/useToastAction";
import { previewAttachment } from "../../api/webEditor";
import { setApiKey } from "../../api/api";
import { MetaforceContext } from "../../contexts";
import * as Constants from "../../utils/constants";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../translations/translationsConstants";

export const AttachmentPreview = () => {
    const { startParameter, publishedAttachmentId } = useContext(MetaforceContext);;
    const [blobUrl, setBlobUrl] = useState();
    const { t: terr } = useTranslation([resources.errors]);

    setApiKey();

    const loadAction = useToastAction();

    const loadData = async () => {
        loadAction.execute(async () => {
            const previewModel = {
                startParameter: startParameter,
                publishedAttachmentId: publishedAttachmentId,
            }
            const res = await previewAttachment(previewModel, startParameter);
            const blob = new Blob([res], { type: "application/pdf" });
            const newBlobUrl = URL.createObjectURL(blob);
            setBlobUrl(newBlobUrl);
        }, terr(translations.errors.failLoadFile));
    }

    useEffect(() => {
        loadData()
    }, []);

    return !loadAction.isExecuting && (
        <main className="tw-h-full tw-w-full">
            {blobUrl && <iframe width='100%' height='100%' src={blobUrl} />}
        </main>
    )
}